<template>
  <q-card
    :class="'member-detail-card ' + (mode === MODE_TYPE.MEMBER_APPROVAL ? 'approval-card' : '')"
    style="padding-bottom: 12px"
  >
    <q-card-section>
      <div class="row justify-between q-mb-md">
        <div class="row items-start member-detail-header-left">
          <ApprovalLabel
            v-if="props.mode !== MODE_TYPE.MEMBER_INFO"
            class="q-mr-sm account-label"
            :admin="props.data.auth_level"
            :approval="props.data.approval_stat"
          />
          <p class="member-detail-card-name q-mb-none q-ml-md">
            {{ props.data.user_name_sei }}{{ blank }}{{ props.data.user_name_mei }}
          </p>
        </div>
        <div v-if="props.mode !== MODE_TYPE.MEMBER_INFO" class="col member-detail-card-date">
          <label class="member-detail-card-item q-mr-md">更新日時</label>
          <span>{{
            props.data.update_timestamp === null
              ? ''
              : props.data.update_timestamp.replace('-', '/').replace('-', '/')
          }}</span>
        </div>
      </div>
      <div class="no-gutters q-ml-sm">
        <div class="work-detail-sub q-mt-xs row" style="width: 100%">
          <label class="member-detail-card-item">会員ID（メールアドレス）</label>
          <p class="q-mb-none member-detail-card-content" style="letter-spacing: 1px">
            {{ props.data.mail_address }}
          </p>
        </div>
        <div class="work-detail q-mt-sm row">
          <div class="row">
            <label class="member-detail-card-item">勤務先 / 学校名</label>
            <p class="q-mb-none member-detail-card-content">{{ props.data.work_school_name }}</p>
          </div>
          <div class="row right-row">
            <label class="member-detail-card-item">所属 / 学部名</label>
            <p class="q-mb-none member-detail-card-content">
              {{ props.data.affiliation_department_name }}
            </p>
          </div>
        </div>
        <div class="work-detail q-mt-sm row address-wrapper" style="width: 100%">
          <label class="member-detail-card-item">所属先住所</label>
          <div class="member-detail-card-content row">
            <p class="q-mb-none addressnumber-area">
              {{ props.data.postal_cd === null ? '' : '〒' }}{{ props.data.postal_cd }}
            </p>
            <p class="q-mb-none address-area">
              {{ props.data.todohuken_name }}{{ props.data.street_address }}
            </p>
          </div>
        </div>
        <div class="work-detail q-mt-sm row">
          <div class="row">
            <label class="member-detail-card-item">所属先電話番号</label>
            <p class="q-mb-none member-detail-card-content">{{ props.data.phone_number }}</p>
          </div>
          <div class="row right-row">
            <label class="member-detail-card-item">ご担当</label>
            <div class="member-detail-card-content">
              <AttributeLabel :attribute="props.data.user_attribute" />
            </div>
          </div>
        </div>
      </div>
    </q-card-section>
  </q-card>
</template>
<script setup lang="ts">
import ApprovalLabel from '../label/ApprovalLabel.vue';
import AttributeLabel from '../label/AttributeLabel.vue';

// どの画面で使用しているかでもらう値を判別
const MODE_TYPE = {
  // 会員情報
  MEMBER_INFO: 'memberinfo',
  // 承認設定
  MEMBER_APPROVAL: 'memberapproval',
};
interface Props {
  // 会員情報
  data: {
    approval_stat: string;
    auth_level: string;
    user_id: string;
    user_name_mei: string;
    user_name_sei: string;
    customer_cd: string;
    mail_address: string;
    phone_number: string;
    work_school_name: string;
    affiliation_department_name: string;
    postal_cd: string;
    todohuken_name: string;
    street_address: string;
    quote_request_mail1: string;
    quote_request_mail2: string;
    quote_request_mail3: string;
    quote_request_mail4: string;
    update_timestamp: string;
    user_attribute: string;
  };
  // 表示モード
  mode: string;
}
const props = defineProps<Props>();

// user_name_seiとuser_name_meiの間に入れる空白
const blank = '　';
</script>
<style scoped>
.approval-card .member-detail-header-left {
  width: calc(100% - 210px);
}

.approval-card .member-detail-card-name {
  width: calc(100% - 88px);
  margin: 0;
}

.member-detail-card.q-card {
  border: 1px solid rgb(0 0 0 / 12%);
}
.member-detail-card .member-detail-card-date {
  max-width: 200px;
  width: 200px;
  padding-top: 5px;
}
.member-detail-card .member-detail-card-date > span {
  font-size: 0.7rem;
  line-height: 0.7rem;
}

.member-detail-card .account-label {
  width: 80px;
  text-align: center;
}

.member-detail-card .member-detail-card-item {
  font-weight: 600;
  margin-right: 15px;
  width: 180px;
  text-align: right;
}

.member-detail-card .right-row .member-detail-card-item {
  width: 100px;
}

.member-detail-card .address-wrapper .member-detail-card-content.row,
.member-detail-card-content {
  width: calc(100% - 195px);
  word-break: break-all;
  margin: 0;
}

.member-detail-card .right-row .member-detail-card-content {
  width: calc(100% - 115px);
}

.member-detail-card .member-detail-card-name {
  font-size: 1.2rem;
  line-height: 1.5rem;
  font-weight: 600;
  letter-spacing: 2px;
  padding-top: 4px;
  word-break: break-all;
}

.work-detail {
  width: 100%;
}

.addressnumber-area {
  width: 80px;
  margin-right: 8px;
}

.address-area {
  width: calc(100% - 88px);
}

.work-detail .row {
  width: 50%;
  margin-right: 2%;
}

.work-detail .row.right-row {
  width: 48%;
  margin: 0;
}
</style>
<style>
.member-detail-card .q-card__section.q-card__section--vert {
  padding: 10px 12px 0;
}
</style>
